import React, { Component } from 'react'
import { AUTH_TOKEN } from '../../constants'


class SavedTranslation extends Component {

  state = {
    identification: "",
    translation: "",
    createdAt: "",
    updatedAt: "",
    language: "",
    id: 0,
  }

  constructor(props) {
    super(props);
    // Don't call this.setState() here!
    this.state = { 
        identification: props.translation.identification,
        translation: props.translation.translation,
        createdAt: props.translation.createdAt,
        updatedAt: props.translation.updatedAt,
        language: props.translation.language,
        id: props.translation.id,
    };
  }

  formatDate(date, isDateTime) {
    return new Intl.DateTimeFormat("de-DE", isDateTime ? {
        year: "numeric",
        month: "numeric",
        day: "2-digit", 
        hour:  "2-digit",
        minute: "2-digit",
       second: "2-digit"
    } : {
        year: "numeric",
        month: "numeric",
        day: "2-digit", 
    }).format(new Date(date))
  }
  
  render() {
    const token = localStorage.getItem(AUTH_TOKEN)
    
    let elements = React.Children.toArray(this.props.children)
    let deleteButton
    let updateButton
    if(elements.length === 2){
        deleteButton = React.cloneElement(elements[0], {id: this.state.id})
        updateButton = React.cloneElement(elements[1], {id: this.state.id, state: this.state})
    }

    return (
        <tr>
            <td>{this.state.id}</td>
            <td><div>{this.state.language}</div></td>
            <td><div>{this.state.identification}</div></td>
            <td><div>{token && !this.props.locked ?
                <input
                value={this.state.translation}
                onChange={e => this.setState({translation: e.target.value})}
                type="text"
                placeholder="translation"
                /> : this.state.translation}</div></td>
            <td><div>{this.formatDate(this.state.createdAt, true)}</div></td>
            <td><div>{this.formatDate(this.state.updatedAt)}</div></td>
            {token && !this.props.locked && <td>{ updateButton }</td>}
            {token && !this.props.locked && <td>{ deleteButton }</td>}
        </tr>
        )
    } 

}

export default SavedTranslation